import { CONFIGURATION_APIS, INVENTORY_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { setWareHouseList } from "@/app_redux/reducers/slices/auth/configuration_slice";
import { IWarehouseDetaildResponse, IWarehouseListResponseData } from "@/api_framework/api_modals/Configuration";

AxiosCurlirize(axios, () => {});
export const useWareHouseDetailsAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const [wareHouseDetails, setWareHouseDetails] = useState<IWarehouseListResponseData>(null);
  const execute = useCallback(
    async (productID: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${CONFIGURATION_APIS?.WAREHOUSE_API?.baseURL}details/${productID}/`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IWarehouseDetaildResponse>) => {
            if (res.data.status === true) {
              setWareHouseDetails(res.data.data);
            } else {
              setWareHouseDetails(null);
            }
          })
          .catch((e: AxiosError) => {
            setWareHouseDetails(null);
            dispatch(setWareHouseList({ data: [] }));
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              //   toast.error("Error while fetching List details");
            }
            if (e.status === 400) {
              //   toast("Product records not found");
            }

            if (e.response.status === 500) {
              toast.error("Server error 500");
            }
          });
      } catch (e: any) {
        setWareHouseDetails(null);
        toast.error("Server Error: " + e.message);
        dispatch(setWareHouseList({ data: [] }));
      }
    },
    [dispatch],
  );
  return { execute, wareHouseDetails };
};
